import React, { useEffect, useState } from "react";
import { useMeeting, usePubSub } from "@videosdk.live/react-sdk";
import useBotSpeech from "../../../../hooks/useBotSpeech";

const AudioBot = ({ isBot, readyToJoin, showCountdown, meetingJoined }) => {
  const { meetingId } = useMeeting();
  const { publish } = usePubSub("CHAT");

  const [audioEnabled, setAudioEnabled] = useState(false);
  const [isBotMutedByBrowser, setIsBotMutedByBrowser] = useState(false);

  // Get bot speaking state from the hook
  const { isBotSpeaking } = useBotSpeech(); //  Updated to get speaking state
  useEffect(() => {
    // Dispatch events for other components that might need them
    if (isBotSpeaking) {
      window.dispatchEvent(new CustomEvent("bot-start-speaking"));
    } else {
      window.dispatchEvent(new CustomEvent("bot-stop-speaking"));
    }
  }, [isBotSpeaking]);
  // Enable audio on user interaction
  useEffect(() => {
    const enableAudio = () => {
      setAudioEnabled(true);

      speechSynthesis.resume();
    };

    const events = ["click", "touchstart", "keydown"];
    events.forEach((event) => {
      document.addEventListener(event, enableAudio, { once: true });
    });

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, enableAudio);
      });
    };
  }, []);

  const handleResumeAudio = () => {
    setAudioEnabled(true);
    setIsBotMutedByBrowser(false);
    speechSynthesis.resume();
  };

  if (!isBot) return null;

  return (
    <>
      {/* Audio enable prompt */}
      {!audioEnabled && meetingJoined && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50">
          <div className="bg-blue-600 text-white px-4 py-2 rounded-full flex items-center space-x-2">
            <span className="text-sm font-medium">
              Click anywhere to enable bot voice
            </span>
          </div>
        </div>
      )}

      {/* Browser mute warning */}
      {isBotMutedByBrowser && audioEnabled && (
        <div className="fixed bottom-24 left-4 bg-yellow-700 text-white px-3 py-2 rounded shadow-lg z-50">
          🔇 Bot voice was blocked by your browser.
          <button
            className="ml-3 px-2 py-1 bg-green-500 rounded text-sm hover:bg-green-600"
            onClick={handleResumeAudio}
          >
            🔊 Unmute Bot Voice
          </button>
        </div>
      )}

      {/* Bot speaking indicator - only show after countdown and when actually speaking */}
      {isBotSpeaking && !showCountdown && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50">
          <div className="bg-blue-600 text-white px-4 py-2 rounded-full flex items-center space-x-2">
            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <span className="text-sm font-normal">Anushka is speaking...</span>
          </div>
        </div>
      )}

      {/* Debug info (remove in production) */}
      {process.env.NODE_ENV === "development" && (
        <div className="fixed bottom-4 right-4 bg-black bg-opacity-75 text-white text-xs p-2 rounded z-50">
          <div>Meeting: {meetingJoined ? "✅" : "❌"}</div>
          <div>Audio: {audioEnabled ? "✅" : "❌"}</div>
          <div>Speaking: {isBotSpeaking ? "✅" : "❌"}</div>
          <div>Countdown: {showCountdown ? "⏳" : "✅"}</div>
        </div>
      )}
    </>
  );
};

export default AudioBot;
